import { useFocusEffect, useLinkTo } from '@react-navigation/native';
import { useCallback, useRef, useState } from 'react';
import { Animated, FlatList, ImageSourcePropType, StyleSheet, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { setHasCompletedOnboarding } from 'store/slices/userDeviceSessionData';

import OnboardingItem from './OnboardingItem';

import BgStep3 from 'assets/Onboarding/bg_init.png';
import BgStep1 from 'assets/Onboarding/bg_prog.png';
import BgStep2 from 'assets/Onboarding/bg_rad.png';

const Onboarding: React.FC = () => {
  const slides = [
    {
      id: '1',
      step: 1,
      title: 'Um universo de conteúdos',
      description: 'Explore conteúdos ao vivo e sob demanda, tudo GRÁTIS!',
      buttonTitle: 'Continuar',
      bgImage: BgStep1 as ImageSourcePropType,
    },
    {
      id: '2',
      step: 2,
      title: 'Você e a Band em sintonia',
      buttonTitle: 'Continuar',
      description: 'Acesse as rádios da Band e podcasts em um só lugar.',

      bgImage: BgStep2 as ImageSourcePropType,
    },
    {
      id: '3',
      step: 3,
      title: 'Pronto para começar?',
      buttonTitle: 'Começar',
      description: 'Ative as notificações do Bandplay e fique por dentro das novidades.',
      bgImage: BgStep3 as ImageSourcePropType,
    },
  ];

  const analytics = useAnalytics();
  const flatListRef = useRef<FlatList>(null);
  const scrollX = useRef(new Animated.Value(0)).current;
  const [currentIndex, setCurrentIndex] = useState(0);
  const linkTo = useLinkTo();
  const dispatch = useDispatch();

  const handleNextSlide = () => {
    if (currentIndex < slides.length - 1) {
      const nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);
      flatListRef.current?.scrollToIndex({ index: nextIndex });
    }
  };

  const handleNexttoLogin = () => {
    linkTo('/entrar');
    dispatch(setHasCompletedOnboarding());
  };

  useFocusEffect(
    useCallback(() => {
      analytics.triggerOnboardingScreenPageViewEvent();
    }, [])
  );

  return (
    <View style={styles.container}>
      <FlatList
        ref={flatListRef}
        data={slides}
        renderItem={({ item }: any) => (
          <OnboardingItem
            key={item.id}
            step={item.step}
            ButtonTitle={item.buttonTitle}
            title={item.title}
            description={item.description}
            bgImage={item.bgImage}
            handleNextSlide={handleNextSlide}
            handleNexttoLogin={handleNexttoLogin}
          />
        )}
        keyExtractor={(item: any) => item.id}
        horizontal
        bounces={false}
        pagingEnabled
        scrollEnabled={false}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { x: scrollX } } }], {
          useNativeDriver: false,
        })}
        scrollEventThrottle={32}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Onboarding;
